import React, {useEffect, useState} from "react";
import {HeaderDashboard, SideNav} from "../DaashBoard/Componat/Header and Side Nav/NavComponant";
import TaxReceipt from "./TaxReceipt";
import {BaseURL} from "../../API/API";
import * as XLSX from 'xlsx';

export default function TaxReceiptPage({gruhkar,panikar,setIsTaxReceipt,Data=[]}) {


    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);
    function PrintPages() {
        // 1. एक टेंपरेरी iframe बनाएं
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '0';
        iframe.style.bottom = '0';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);

        const doc = iframe.contentWindow.document;

        // 2. मौजूदा पेज की सभी CSS स्टाइल्स को iframe में कॉपी करें
        const styles = document.querySelectorAll('link[rel="stylesheet"], style');
        let stylesHtml = '';
        styles.forEach(style => {
            stylesHtml += style.outerHTML;
        });

        // 3. प्रिंट होने वाले कंटेंट का HTML निकालें
        const printContent = document.getElementById("printPage").innerHTML;

        // 4. iframe के अंदर HTML और CSS लिखें
        doc.open();
        doc.write(`
        <html>
            <head>
                <title>Print Receipts</title>
                ${stylesHtml}
            </head>
            <body>
                ${printContent}
            </body>
        </html>
    `);
        doc.close();

        // 5. कंटेंट लोड होने के बाद प्रिंट करें और iframe को हटा दें
        iframe.contentWindow.focus();
        setTimeout(() => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        }, 500); // 500ms का डिले ताकि CSS पूरी तरह लोड हो जाए
    }

    function SearchData(data,searchA,searchC) {
        const match = data.find(
            (row) =>
                String(row['ColA'] || '').trim() === searchA.trim() &&
                String(row['ColC'] || '').trim() === searchC.trim()
        );
        return match;
    }

    return (
        <main className={`p-4 w-100 main`}>
            <div className="card p-2 ">
                <div className="d-flex justify-content-between">
                    <button onClick={()=>setIsTaxReceipt(false)} className="btn btn-primary">Back</button>
                    <button onClick={PrintPages} className="btn btn-primary">Print</button>
                </div>
            </div>
            <div id="printPage" className="mt-2">
                {
                    // .slice().reverse()
                    //[...Data]
                    Data.map((item, index) => (
                        <div className="receipt-container" key={item.id || index}>
                            <TaxReceipt index={index} item={item} gruhkar={SearchData(gruhkar,item.Property_No,item.Owner_Name)} panikar={SearchData(panikar,item.Property_No,item.Owner_Name)} />
                        </div>
                    ))
                }
            </div>
        </main>
    )

    return (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    <div className="card p-2 ">
                      <div className="d-flex justify-content-end">
                          <button onClick={PrintPages} className="btn btn-primary">Print</button>
                      </div>
                    </div>
                    <div id="printPage" className="mt-2">
                        <div className="receipt-container"><TaxReceipt/></div>
                        <div className="receipt-container"><TaxReceipt/></div>
                        <div className="receipt-container"><TaxReceipt/></div>
                        <div className="receipt-container"><TaxReceipt/></div>
                    </div>
                </main>
            </div>
        </div>
    )
}